<template>
  <a class="btn btn-danger">削除</a>
</template>


<script type="text/javascript">
export default {

}
</script>